<template>
	<div class="wrap">
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test">首页设置</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card>
			
			<!-- 表格数据 -->
			<h3>视频中心修改：</h3>
			<el-table :data="videoList" border :strip="true">
				<el-table-column label="ID" width="70px" prop="id"></el-table-column><!-- type="index" -->
				<el-table-column label="标题" prop="title"></el-table-column>
				<el-table-column label="视频封面" prop="coverPicture">
					<template slot-scope="scope">
						<img :src="$imgTitle+scope.row.coverPicture" style="width: 150px;height: 150px;" />
					</template>
				</el-table-column>
				<el-table-column label="视频链接" prop="videoLink"></el-table-column>
				<el-table-column label="添加时间" prop="createTime">
					<template slot-scope="scope">{{scope.row.createTime | dataFormat }}</template>
				</el-table-column>

				<el-table-column label="操作">
					<template slot-scope="scope">
						<!-- <el-button type="primary" @click="gotoEdit(scope.row.id)">编辑</el-button> -->
						<el-button type="danger" @click="delVideo(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			
			<el-button class="addBtn" type="success" @click="addVideo">添加视频</el-button>
			<el-row style="margin-top: 20px;">
				<el-tag type="warning">首页的其他修改请联系前端修改</el-tag>
			</el-row>
			
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				videoList: []
			}
		},
		created() {
			this.getVieoList();
			var data = {
				"data": {
					"code": 0,
					"message": "success.",
					"data": [{
						"id": 5,
						"createTime": 1591930546000,
						"updateTime": null,
						"title": "宜关",
						"videoLink": "%E5%AE%9C%E5%85%B3.mp4",
						"weights": 6,
						"coverPicture": "%E5%AE%9C%E5%85%B3.png"
					}, {
						"id": 6,
						"createTime": 1590654410000,
						"updateTime": null,
						"title": "森仕科技传媒",
						"videoLink": "%E6%A3%AE%E4%BB%95%E7%A7%91%E6%8A%80%E4%BC%A0%E5%AA%92.mp4",
						"weights": 5,
						"coverPicture": "%E6%A3%AE%E4%BB%95%E7%A7%91%E6%8A%80%E4%BC%A0%E5%AA%92.png"
					}, {
						"id": 4,
						"createTime": 1590654410000,
						"updateTime": null,
						"title": "润天",
						"videoLink": "%E6%B6%A6%E5%A4%A9.mp4",
						"weights": 4,
						"coverPicture": "%E6%B6%A6%E5%A4%A9.png"
					}, {
						"id": 3,
						"createTime": 1590654410000,
						"updateTime": null,
						"title": "慕茹姬",
						"videoLink": "%E6%85%95%E8%8C%B9%E5%A7%AC%E5%93%81%E7%89%8C.mp4",
						"weights": 3,
						"coverPicture": "%E6%85%95%E5%A6%82%E5%A7%AC.png"
					}, {
						"id": 2,
						"createTime": 1590654410000,
						"updateTime": null,
						"title": "九航集团",
						"videoLink": "%E4%B9%9D%E8%88%AA%E9%9B%86%E5%9B%A2.mp4",
						"weights": 2,
						"coverPicture": "%E4%B9%9D%E8%88%AA%E9%9B%86%E5%9B%A2.png"
					}, {
						"id": 1,
						"createTime": 1590654410000,
						"updateTime": null,
						"title": "健驰",
						"videoLink": "%E5%81%A5%E9%A9%B0.mp4",
						"weights": 1,
						"coverPicture": "%E5%81%A5%E9%A9%B0.png"
					}]
				},
				"status": 200,
				"statusText": "",
				"headers": {
					"date": "Sun, 28 Jun 2020 06:41:22 GMT",
					"transfer-encoding": "chunked",
					"content-type": "application/json;charset=UTF-8"
				},
				"config": {
					"url": "/v1/official/video/center",
					"method": "get",
					"params": {},
					"headers": {
						"Accept": "application/json, text/plain, */*"
					},
					"baseURL": "http://120.24.239.84:8701",
					"transformRequest": [null],
					"transformResponse": [null],
					"timeout": 0,
					"xsrfCookieName": "XSRF-TOKEN",
					"xsrfHeaderName": "X-XSRF-TOKEN",
					"maxContentLength": -1
				},
				"request": {}
			}
		},
		methods: {
			async getVieoList() {
				const res = await this.$http.post('/v1/official/manag/video/list', { //查询视频中心 
					request:{

					}
				})
				if(res.data.code == 0){
					this.videoList = res.data.data.list;
				}else if(res.data.code == 102){
					this.$router.push({
						path:'/login'
					})
				}
				console.log(JSON.stringify(res))
			},
			addVideo(){
				this.$router.push({
					path:'/shoyeaddvideo'
				})
			},
			async delVideo(id){
				console.log(id)
				const confirmResult = await this.$confirm(
				  '此操作将删除该视频, 是否继续?',
				  '提示',
				  {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				  }
				).catch(err => err)
				if (confirmResult !== 'confirm') {
				  return this.$message.info('已取消删除！')
				}
				var res = await this.$http.get('/v1/official/manag/deleteVideoById',{
					params:{
						id:id
					}
				})
				console.log(JSON.stringify(res))
				if(res.data.code == 0){
					this.$message.success('删除成功')
					this.getVieoList();
				}else{
					this.$message.success(res.data.message)
				}
				
			}
		}
	}
</script>

<style lang="less" scoped>
	.addBtn{
		margin-top: 20px;
	}
</style>
